import { observable, action, makeObservable } from "mobx";
import { Config } from "src/config/config";
import { RootStore } from "./RootStore";
import { Back } from "src/types";

export interface ListParameters {
    searchQuery?: string;
    scrollPosition?: number;
    paginationPage?: number;
    filterValue?: string;
    sortValue?: string;
}

const HISTORY_STACK_MAX_SIZE = 20;

export class NavigationStore {
    @observable active = true;
    rootStore: RootStore;

    @observable closeNavTarget = "";
    @observable currentTitle = "";
    @observable appheaderTitle = "";
    @observable currentSubtitle: string | null = null;
    @observable back: Back | null = null;
    @observable.ref actionButtonLeft: React.ReactNode | null = null;
    @observable.ref actionButtonMiddle: React.ReactNode | null = null;
    @observable.ref actionButtonRight: React.ReactNode | null = null;

    @observable listMap: Map<string, ListParameters> = new Map();
    @observable historyStack: string[] = [];

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeObservable(this);
    }

    @action
    setActive = (active: boolean) => {
        this.active = active;
    };

    @action
    getPreviousPage = () => {
        if (this.historyStack.length >= 2) {
            return this.historyStack[this.historyStack.length - 2];
        } else {
            return undefined;
        }
    };

    @action
    addToHistoryStack = (url: string) => {
        if (this.historyStack.length < HISTORY_STACK_MAX_SIZE) {
            this.historyStack.push(url);
        } else {
            this.historyStack.shift();
            this.historyStack.push(url);
        }
    };

    @action
    setListMapValue = (listIdentifier: string, value: ListParameters) => {
        this.listMap.set(listIdentifier, value);
    };

    @action
    getListMapValue = (key: string) => {
        return this.listMap.get(key);
    };

    @action
    setActionButtonMiddle = (actionButton: React.ReactNode | null) => {
        this.actionButtonMiddle = actionButton;
    };
    @action
    setActionButtonLeft = (actionButton: React.ReactNode | null) => {
        this.actionButtonLeft = actionButton;
    };
    @action
    setActionButtonRight = (actionButton: React.ReactNode | null) => {
        this.actionButtonRight = actionButton;
    };
    @action
    resetActionButtons = () => {
        this.actionButtonRight = null;
        this.actionButtonLeft = null;
        this.actionButtonMiddle = null;
    };

    @action
    setCurrentSubTitle = (currentSubTitle: string | null) => {
        this.currentSubtitle = currentSubTitle;
    };

    @action
    setBackbutton = (target: string | null, label?: string) => {
        //Remove Backbutton
        if (target === null) {
            this.back = null;
            return;
        }
        this.back = { label: label || "", to: target };
    };

    @action
    setTitle = (newTitle: string) => {
        const titles: string[] = [];

        if (newTitle) {
            titles.push(newTitle);
        } else {
            titles.push(Config.appname);
        }
        this.currentTitle = titles.join(" - ");
        this.appheaderTitle = newTitle;
    };

    @action
    setTabTitle = (newTitle: string) => {
        this.currentTitle = newTitle;
    };

    @action
    setCloseNavTarget = (newCloseNavTarget: string) => {
        this.closeNavTarget = newCloseNavTarget;
    };

    @action
    reset = () => {
        this.closeNavTarget = "";
        this.currentTitle = "";
        this.appheaderTitle = "";
        this.currentSubtitle = null;
        this.back = null;
    };
}
